const dynamicParameterFields = {
    required: "This field is required",
    notSupportedField: "This field type is not supported",
    parametersNotNecessary: "Parameters are not necessary for this agent",
    autoFilled: "From Integration",
    autoFilledFromIntegration: "Field automatically filled from selected integration"
};

export default dynamicParameterFields;